"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const syntax_1 = require("../error/syntax");
const constant_1 = require("../node/expression/constant");
const node_1 = require("../node");
class TwingTokenParserUse extends token_parser_1.TwingTokenParser {
    parse(token) {
        let template = this.parser.getExpressionParser().parseExpression();
        let stream = this.parser.getStream();
        if (template.getType() !== node_1.TwingNodeType.EXPRESSION_CONSTANT) {
            throw new syntax_1.TwingErrorSyntax('The template references in a "use" statement must be a string.', stream.getCurrent().getLine(), stream.getSourceContext());
        }
        let targets = new Map();
        if (stream.nextIf(token_1.TwingToken.NAME_TYPE, 'with')) {
            do {
                let name = stream.expect(token_1.TwingToken.NAME_TYPE).getValue();
                let alias = name;
                if (stream.nextIf(token_1.TwingToken.NAME_TYPE, 'as')) {
                    alias = stream.expect(token_1.TwingToken.NAME_TYPE).getValue();
                }
                targets.set(name, new constant_1.TwingNodeExpressionConstant(alias, token.getLine(), token.getColumn()));
                if (!stream.nextIf(token_1.TwingToken.PUNCTUATION_TYPE, ',')) {
                    break;
                }
            } while (true);
        }
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        this.parser.addTrait(new node_1.TwingNode(new Map([['template', template], ['targets', new node_1.TwingNode(targets)]])));
        return new node_1.TwingNode();
    }
    getTag() {
        return 'use';
    }
}
exports.TwingTokenParserUse = TwingTokenParserUse;
